import { Registerer } from 'sip.js';
import type { RegistererRegisterOptions } from 'sip.js';

type Otpravka = ReturnType<Registerer['register']>;

/**
 * Регистратор, который не шлёт станции второй REGISTER, пока первый ждёт финального ответа.
 *
 * Обращение №90 (прибор ошибок, №570, 13.10): «REGISTER request already in progress, waiting
 * for final response». Регистрацию просят из нескольких мест: сторож обрыва, сторож подключения
 * (такт, возврат на вкладку, возврат сети) и сама библиотека — плановым продлением на половине
 * срока. Пока запрос в пути, библиотека второй не отправляет и отклоняет обещание (RFC 3261
 * §10.2). Наши вызовы этот отказ ловят, а своё плановое продление библиотека зовёт из таймера
 * без обработчика: попало на наш ещё не отвеченный запрос — отказ уходит в прибор ошибок.
 * У сторожа обрыва тот же отказ читался как «связь не поднялась», и он рвал соединение заново.
 *
 * Библиотека зовёт продление как `this.register()`, поэтому дверь одна — здесь: запрос в пути —
 * нового не шлём, отдаём тот, что уже идёт. Ответ на него сам переведёт таймеры продления, а не
 * придёт — библиотека снимет регистрацию, и сторож подключения отправит новый запрос.
 *
 * Признак «ждёт ответа» библиотека ведёт сама (`waiting`); в типах он закрыт, в объекте есть.
 * Свой счётчик не заводим: часть ответов библиотека разбирает, не сообщая вызвавшему (423,
 * ответ без нашего адреса), и свой счётчик на них залип бы — регистрация не вернулась бы
 * до перезагрузки страницы.
 *
 * Ловушка — telephony-register-odin-za-raz-i90.test.ts.
 */
export class RegistratorPoOdnomu extends Registerer {
  private vPuti: Otpravka | null = null;

  public register(options?: RegistererRegisterOptions): Otpravka {
    if (this.vPuti && zhdyotOtveta(this)) return this.vPuti;

    this.vPuti = super.register(options);
    return this.vPuti;
  }
}

function zhdyotOtveta(registerer: Registerer): boolean {
  return (registerer as unknown as { waiting?: boolean }).waiting === true;
}
